import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Button, Row, Col, Form, Card } from 'react-bootstrap'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import TxPackage from './TxPagekage'
import getDefaultTxPackage from '../utils/getDefaultTxPackage'
import JitaiOptionalTxPackageAssignmentSetting from '../../jitai_module/components/JitaiOptionalTxPackageAssignmentSetting'

// Each item in group.tx_package_list here shall consist of name and _id
// While when saving as tx_package_list in study model, it shall be transformed (at backend) to a list of txPackage ids only
export const GroupTxPackages = ({
  group,
  goToLogin,
  readOnly,
  optionalSettingsEnabled,
  jitaiDecisionRules,
  nextStageOptionalTxPackageSettings,
  onAddOptionalSetting,
  onDeleteOptionalSetting,
  referencedOptionalPackageIds,
  study,
  stage,
  hasOptionalModulesInNextStage,
}) => {
  const [packageList, setPackageList] = useState([])

  // TX Materials data - read from redux (fetched at StudyEditScreen level)
  const txPageList = useSelector((state) => state.txPageList)
  const { txPages } = txPageList

  useEffect(() => {
    // TX materials fetching is now handled at the StudyEditScreen level to avoid duplicate requests
    setPackageList(group.tx_package_list)
  }, [group])

  // Dependency: react-beautiful-dnd
  const handleDrop = (droppedItem) => {
    //Ignore drop outside droppable container
    if (!droppedItem.destination) return
    let updatedList = [...group.tx_package_list]
    // Remove dragged item
    let [reorderedItem] = updatedList.splice(droppedItem.source.index, 1)
    // Add dropped item
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem)
    // Update State
    group.tx_package_list = updatedList
  }

  const addTxPackage = () => {
    group.tx_package_list = [...group.tx_package_list, getDefaultTxPackage()]
    setPackageList(group.tx_package_list)
  }

  const deleteTxPackage = (index) => {
    let temp = []
    for (let i = 0; i < group.tx_package_list.length; ++i) {
      if (i === index) {
        continue
      } else {
        temp.push(group.tx_package_list[i])
      }
    }
    group.tx_package_list = temp
    setPackageList(temp)
  }

  return (
    <>
      <div style={{ marginBottom: '18px' }}>
        <Form.Label style={{ whiteSpace: 'normal' }}>
          Treatment Chapter(s) Added after Group Assignment
        </Form.Label>

        {group.tx_package_list.length > 0 && (
          <DragDropContext onDragEnd={handleDrop}>
            <Droppable droppableId='group-tx-package-list-container'>
              {(provided) => (
                <Card
                  className='p-2 rounded'
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {packageList.map((txPackage, index) => (
                    <Draggable
                      key={'group_tx_package_draggable_' + group._id + index}
                      draggableId={
                        'group_tx_package_draggable_' + group._id + index
                      }
                      index={index}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.dragHandleProps}
                          {...provided.draggableProps}
                        >
                          <TxPackage
                            key={'group_tx_package_' + group._id + Date()}
                            group={group}
                            index={index}
                            handleDelete={() => {
                              deleteTxPackage(index)
                            }}
                            txPages={txPages}
                            readOnly={readOnly}
                            referencedOptionalPackageIds={referencedOptionalPackageIds}
                          ></TxPackage>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </Card>
              )}
            </Droppable>
          </DragDropContext>
        )}

        {!readOnly && (
          <Row>
            <Col md={12}>
              <Button
                style={{ width: '100%', marginTop: '5px' }}
                variant='primary'
                onClick={addTxPackage}
              >
                Add Treatment Chapter
              </Button>
            </Col>
          </Row>
        )}

        {optionalSettingsEnabled && (
          <>
            {nextStageOptionalTxPackageSettings && nextStageOptionalTxPackageSettings.map((setting, index) => (
              <JitaiOptionalTxPackageAssignmentSetting
                key={'optional_tx_package_setting' + group._id + index}
                group={group}
                index={index}
                jitai_decision_rules={jitaiDecisionRules || []}
                study={study}
                stage={stage}
                handleDelete={() => onDeleteOptionalSetting(index)}
              />
            ))}

            {!readOnly && (
              <Row>
                <Col md={12}>
                  <Button
                    style={{ width: '100%', marginTop: '5px' }}
                    variant='outline-primary'
                    onClick={() => {
                      if (!jitaiDecisionRules || jitaiDecisionRules.filter(rule => rule.type === 'optionalTxPackageAssignment').length === 0) {
                        window.alert('You need to create at least one Optional Treatment Chapter Assignment JITAI decision rule first.')
                        return
                      }
                      if (!hasOptionalModulesInNextStage) {
                        window.alert('No optional treatment chapters available in the next stage. Please mark treatment chapters as "Optional Module" on at least one next-stage participant group and save the study first.')
                        return
                      }
                      onAddOptionalSetting()
                    }}
                  >
                    Add Optional Chapter Assignment Rule
                  </Button>
                </Col>
              </Row>
            )}
          </>
        )}
      </div>
    </>
  )
}

export default GroupTxPackages
